module.exports = __webpack_public_path__ + "static/img/wealth_level_76.d621df1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_76.png
// module id = nhks
// module chunks = 0